import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  // Connect to socket server
  connect() {
    if (this.socket?.connected) return this.socket;

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 10
    });

    this.socket.on('connect', () => {
      console.log('🔌 Socket connected:', this.socket.id);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('❌ Socket disconnected:', reason);
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    return this.socket;
  }

  // Disconnect from socket server
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  // Get socket instance
  getSocket() {
    if (!this.socket) {
      this.connect();
    }
    return this.socket;
  }

  // Subscribe to vehicles
  subscribeToVehicles(callback) {
    const socket = this.getSocket();
    socket.emit('subscribe:vehicles');
    
    socket.on('vehicles:initial', callback);
    socket.on('vehicle:location', callback);
    socket.on('vehicle:created', callback);
    socket.on('vehicle:updated', callback);
    socket.on('vehicle:deleted', callback);
  }

  // Subscribe to specific vehicle
  subscribeToVehicle(vehicleId, callback) {
    const socket = this.getSocket();
    socket.emit('subscribe:vehicle', vehicleId);
    socket.on('vehicle:update', callback);
  }

  // Unsubscribe from vehicle
  unsubscribeFromVehicle(vehicleId) {
    const socket = this.getSocket();
    socket.emit('unsubscribe:vehicle', vehicleId);
    socket.off('vehicle:update');
  }

  // Subscribe to alerts
  subscribeToAlerts(callback) {
    const socket = this.getSocket();
    socket.emit('subscribe:alerts');
    
    socket.on('alerts:initial', callback);
    socket.on('alert:new', callback);
  }

  // Subscribe to geofence events
  subscribeToGeofences(callback) {
    const socket = this.getSocket();
    socket.on('geofence:created', callback);
    socket.on('geofence:updated', callback);
    socket.on('geofence:deleted', callback);
    socket.on('geofence:breach', callback);
  }

  // Generic event listener
  on(event, callback) {
    const socket = this.getSocket();
    socket.on(event, callback);
    this.listeners.set(event, callback);
  }

  // Remove event listener
  off(event) {
    const socket = this.getSocket();
    const callback = this.listeners.get(event);
    if (callback) {
      socket.off(event, callback);
      this.listeners.delete(event);
    }
  }

  // Emit event
  emit(event, data) {
    const socket = this.getSocket();
    socket.emit(event, data);
  }
}

// Create singleton instance
const socketService = new SocketService();

export default socketService;
